import { div, udex } from '../../../scripts/dom-builder.js';
import { ACCORDION_HEADLINE_LEVEL } from '../finder-eccn-matrix.constants.js';

export function getAccordion(block) {
  const accordionData = Array.from(
    block.querySelectorAll('div.finder-eccn-matrix > div'),
  );

  if (accordionData.length < 2) {
    return udex('accordion', {
      headlineLevel: ACCORDION_HEADLINE_LEVEL,
      hideExpandButton: true,
    });
  }

  const titles = accordionData[0].querySelectorAll(':scope > div');
  const contents = accordionData[1].querySelectorAll(':scope > div');

  const items = [];
  titles.forEach((titleEl, i) => {
    const contentEl = contents[i];
    if (!contentEl) {
      return;
    }

    const item = udex(
      'accordion-item',
      {
        label: titleEl.textContent.trim(),
        expanded: false,
        labelSize: 'Standard',
      },
      div(contentEl.cloneNode(true)),
    );

    requestAnimationFrame(() => {
      if (item.shadowRoot) {
        const style = document.createElement('style');
        style.textContent = `
          .udex-accordion-item__header 
          .udex-accordion-item__icon-wrapper:not(.udex-accordion-item__label-icon-wrapper) {
            margin-inline-start: revert;
            order: -1;
          }
          udex-divider {
            display: none;
          }
          @media screen and (min-width: 640px) {
            .udex-accordion-item__header {
              padding: 0 var(--udexSpacer12) !important;
            }
          }
        `;
        item.shadowRoot.append(style);
      }
    });

    items.push(item);
  });

  return udex(
    'accordion',
    {
      headlineLevel: ACCORDION_HEADLINE_LEVEL,
      hideExpandButton: true,
    },
    ...items,
  );
}
